import React, { useEffect } from "react";
import CameraIcon from "assets/svgIcons/CameraIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { siteId as siteNumber } from "redux/reduxToolkitServices/_commonApiCalls/api";
import { useHookstate } from "@hookstate/core";
import {
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
} from "globalStore/globalStore";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const Welcome = () => {
  const { t } = useTranslation();
  const { sideDrawerActiveTabState, subNavDataState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getWelcomeAdsData, getDashboardFeatureSetStatus } =
    useSelector((state) => state.commonReducers) || "";

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null
    ) {
      dispatch(COMMON_SERVICES.getWelcomeAdsImageServices(siteId.get()));
    }
  }, [getDashboardFeatureSetStatus, siteId.get()]);

  return (
    <div className="h-100">
      <div className="header">
        <CameraIcon />
        <p>{t("Welcome_Screen")}</p>
      </div>
      <div className="box-body welcome-screen">
        <img src={getWelcomeAdsData.base64data} alt="welcome-screen" />
      </div>
    </div>
  );
};

export default Welcome;
